<template>
  <div>
    <!-- <v-subheader>Datos del evento</v-subheader> -->
    <!-- Dates tile -->
    <span class="tittlesDetails">Fechas de evento</span>
    <v-list-tile>
      <v-list-tile-avatar>
        <img :src="require('@/assets/notices/SKLB-Evento.png')" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <!-- <v-list-tile-title>Fechas</v-list-tile-title> -->
        <v-list-tile-sub-title>
          <span>
            <strong>Inicio:</strong>
            {{ notice.startDate | dateFormat }}
          </span>
          <span v-if="notice.endDate != null"> | </span>
          <span v-if="notice.endDate != null">
            <strong>Término:</strong>
            {{ notice.endDate | dateFormat }}
          </span>
        </v-list-tile-sub-title>
        <v-list-tile-sub-title>
          <span v-if="notice.type == 'E'">
            <strong>Fecha de inicio de evento:</strong>
            {{ this.notice.startEventDate | dateFormat }}
          </span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Dates tile -->

    <!-- Place tile -->
    <!-- <v-list-tile avatar>
      <v-list-tile-avatar>
        <img :src="require('@/assets/mapIcons/if_map-marker_3688470.png')" />
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title>Lugar</v-list-tile-title>
        <v-list-tile-sub-title>{{ notice.place }}</v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile> -->
    <!-- Place tile -->

    <!-- Assistance tile -->
    <span class="tittlesDetails">Asistencia del tutor</span>
    <v-btn flat fab small @click="showParentAttendance">
      <v-icon>remove_red_eye</v-icon>
    </v-btn>
    <v-list-tile>
      <!-- <v-list-tile-avatar>
        <v-icon v-if="notice.assistanceRequired" color="red" >check</v-icon>
        <v-icon v-else color="red" >clear</v-icon>
      </v-list-tile-avatar> -->
      <v-list-tile-content>
        <!-- <v-list-tile-title>Asistencia del tutor</v-list-tile-title> -->
        <v-list-tile-sub-title>
          <span v-if="notice.assistanceRequired" class="redText">
            Requerido
          </span>
          <span v-else class="grayText">No requerido</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Assistance tile -->

    <!-- Assistance tile -->
    <span class="tittlesDetails">Asistencia del Alumno</span>
    <v-btn flat fab small @click="showStudentAttendance">
      <v-icon>remove_red_eye</v-icon>
    </v-btn>
    <v-list-tile>
      <!-- <v-list-tile-avatar>
        <v-icon v-if="notice.assistanceRequired" color="red" >check</v-icon>
        <v-icon v-else color="red" >clear</v-icon>
      </v-list-tile-avatar> -->
      <v-list-tile-content>
        <!-- <v-list-tile-title>Asistencia del tutor</v-list-tile-title> -->
        <v-list-tile-sub-title>
          <span v-if="notice.attendanceStudentRequired" class="redText">
            Requerido
          </span>
          <span v-else class="grayText">No requerido</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Assistance tile -->

    
    <!-- Parent's confirmation tile -->

    <!-- Parent's confirmation tile -->
    <span class="tittlesDetails">Confirmación del tutor:</span>
    <v-btn flat fab small @click="showParentConfirmation">
      <v-icon>remove_red_eye</v-icon>
    </v-btn>
     <!-- Parent's confirmation tile -->
    <v-list-tile avatar>
      <v-list-tile-avatar>
        <v-icon v-if="notice.confirmParent" color="green" large>check</v-icon>
        <v-icon v-else color="red" large>clear</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <!-- <v-list-tile-title>Confirmación del tutor</v-list-tile-title> -->
        <v-list-tile-sub-title>
          <span pb-3 v-if="notice.confirmParent">
            Confirmado
          </span>
          <span v-else>No Confirmado</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <!-- Parent's confirmation tile -->
    <!-- <v-list-tile>
            <v-list-tile-avatar>
        <v-icon v-if="notice.authParentRequired" color="red">check</v-icon>
        <v-icon v-else color="green">clear</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <span pb-3 v-if="notice.confirmParent" class="redText">
            Requerido
          </span>
          <span v-else class="grayText">No requerido</span>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile> -->
    <!-- Parent's confirmation tile -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["notice"],
  filters: {
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  },
  methods: {
    showParentConfirmation() {
      this.$emit("parent-confirm");
    },
    showParentAttendance() {
      this.$emit("parent-attendance");
    },
    showStudentAttendance() {
      this.$emit("student-attendance");
    }
  },
};
</script>

<style>
</style>